import React, { useReducer } from 'react'
export const DemoContext = React.createContext()
export const DemoConsumer = DemoContext.Consumer

const getRef = () => {
    const curUrl = new URL(document.location.href)
    const curRef = curUrl.searchParams.get('ref')
    // analytics.sendPageName(curRef)
    switch (curRef) {
    case 'home':
    case 'removebackgroundapi':
    case 'standalone':
    case 'integrationhtml':
    case 'integrationnpm':
    case 'demohtml':
    case 'demoapp':
        return curRef
    default:
        return 'home'
    }
}

const isMobilePlatform = () => {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(navigator.userAgent)){
        return true
    }else{
        return false
    }
}

const initialState = {
    wait: false,
    selectedFiles: [],
    thumbs: [],
    customFiles: [],
    outputFiles: null,
    aperitif: null,
    uploadProgress: 0,
    utStorage: null,
    upload: false,
    outputUpdate: false,
    refineFiles: [],
    page: getRef(),
    showSideNav: false,
    isMobile: isMobilePlatform(),
    apiStatus: "",
    outputComps: null
}

const reducer = (state, anAction) => {
    switch (anAction.type) {
    case 'set-wait': {
        const { wait } = anAction.payload
        return { ...state, wait: wait }
    }
    case 'set-selectedFiles': {
        const { selectedFiles } = anAction.payload
        return { ...state, selectedFiles: selectedFiles }
    }
    case 'set-refineFiles': {
        const { refineFiles } = anAction.payload
        return { ...state, refineFiles: refineFiles }
    }
    case 'set-thumbs': {
        const { thumbs } = anAction.payload
        return { ...state, thumbs: thumbs }
    }
    case 'set-aperitif': {
        const { aperitif } = anAction.payload
        // console.log(JSON.stringify(aperitif, null, 2))
        return { ...state, aperitif: aperitif }
    }
    case 'set-uploadProgress': {
        const { uploadProgress } = anAction.payload
        return { ...state, uploadProgress: uploadProgress }
    }
    case 'set-utStorage': {
        const { utStorage } = anAction.payload
        return { ...state, utStorage: utStorage }
    }
    case 'set-customFiles': {
        const { customFiles } = anAction.payload
        return { ...state, customFiles: customFiles }
    }
    case 'set-outputFiles': {
        const { outputFiles } = anAction.payload
        return { ...state, outputFiles: outputFiles }
    }
    case 'set-outputUpdate': {
        const { outputUpdate } = anAction.payload
        return { ...state, outputUpdate: outputUpdate }
    }
    case 'set-page': {
        const { page } = anAction.payload
        // console.log(`PAGE: ${page}`)
        return { ...initialState, page, wait: false, ut: state.ut }
    }
    case 'set-apiStatus': {
        const { apiStatus } = anAction.payload
        return { ...state, apiStatus: apiStatus }
    }
    case 'set-outputComps': {
        const { outputComps } = anAction.payload
        return { ...state, outputComps: outputComps }
    }
    case 'reset': {
        return { ...initialState, page: state.page, wait: false, ut: state.ut }
    }
    case 'toggle-side-nav': {
        const { showSideNav } = anAction.payload
        return { ...state, showSideNav: showSideNav }
    }
    case 'upload':
        return { ...state, upload: anAction.payload }
    default:
        // console.log(`anAction.type: ${anAction.type}`)
        // throw new Error()
        alert('Something went wrong!')
    }
}

export default function EasybakeProvider ({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState)
    const value = { ...state, dispatch }
    return (
        <DemoContext.Provider value={value}>
            {children}
        </DemoContext.Provider>
    )
}
